import React from 'react'
import { Input as SonansInput, Icon } from '@sonans/components'
import { Popup } from './Popup'

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: React.ReactNode
    noIcon?: boolean
    popupTitle?: string | React.ReactNode
    popupContent?: string | React.ReactNode
}

export function Input({
    label,
    noIcon,
    popupTitle = '',
    popupContent,
    ...props
}: Props) {
    const labelStr = typeof label === 'string' ? label : ''

    return (
        <div className="flex flex-col gap-1 w-full">
            {popupContent && (
                <div className="flex gap-2 items-center">
                    {label && !labelStr && label}
                    <Popup title={popupTitle} content={popupContent} />
                </div>
            )}
            <SonansInput
                id={props.id ?? ''}
                label={labelStr}
                iconSlot={!noIcon ? <Icon icon="search" /> : undefined}
                {...(props as any)}
            />
        </div>
    )
}
